<div class="drawer-root d-md-none" role="dialog" aria-modal="true" aria-label="Menú de navegación">

  <button
    type="button"
    class="drawer-backdrop"
    tabindex="-1"
    aria-hidden="true"
    (click)="close()">
  </button>

  <nav #panel class="drawer-panel bg-primary" aria-label="Menú principal">

    <div class="d-flex justify-content-end px-2">
      <button
        type="button"
        #closeButton
        class="btn drawer-close text-white"
        aria-label="Cerrar menú"
        (click)="close()">
        <i class="material-icons" aria-hidden="true">close</i>
      </button>
    </div>

    <div class="row mx-0 pt-2 pb-5">
      @for (menu of menuData; track menu.route) {
        <app-menu-item [menuItem]="menu"></app-menu-item>
      }
    </div>

  </nav>

</div>
